var map = {
	"./index.js": 173,
	"./split-pane-mode.jsx": 321
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1214;


//////////////////
// WEBPACK FOOTER
// ./src/core/plugins/split-pane-mode/components \.jsx?$
// module id = 1214
// module chunks = 0